module.exports = __webpack_public_path__ + "img/IMG_3945_L.9c556688.webp";